import { gql } from '@apollo/client'
import { MUTATION_STATE } from 'api/fragments'

const PAYLOAD_TYPE = 'UpdateVoohCampaignCreationPayload'

export const UPDATE_VOOH_CAMPAIGN_CREATION = gql`
  ${MUTATION_STATE(PAYLOAD_TYPE)}
  mutation updateVoohCampaignCreation(
    $voohCreationId: ID!
    $details: String!
    $mediaFormat: VoohMediaFormatEnum!
    $duration: Int!
    $hourFrequency: Int
  ) {
    updateVoohCampaignCreation(
      input: {
        voohCreationId: $voohCreationId
        details: $details
        mediaFormat: $mediaFormat
        duration: $duration
        hourFrequency: $hourFrequency
      }
    ) {
      voohCampaign {
        publishable
      }
      voohCreation {
        id
      }
      ...MutationState${PAYLOAD_TYPE}Fields
    }
  }
`
